import {Form, Input} from 'antd';
import React, {ReactElement} from 'react';

import {DateCell} from 'components/table/columns/date-cell/date-cell';
import {IGroupCompanyProtocolForm} from 'pages/ais/organization-structure-v5/model/types';
import {
    GroupCompanyOrgInfoItem,
} from 'pages/ais/organization-structure-v5/ui/forms/group-company-protocol-form/group-company-org-Info-Item';

import styles from '../group-company-form/group-company-form.module.less';

export const GroupCompanyProtocolForm = (
    {fields, formInstance}: IGroupCompanyProtocolForm
): ReactElement => (
    <Form
        layout="vertical"
        form={formInstance}
    >
        <section>
            <div>
                <h4 className={styles['group-company-form__title']}>Основные сведения</h4>
                <div className="d-flex gap-2">
                    <Form.Item
                        name="requestId"
                        label="Номер запроса"
                        className={styles['group-company-form__half-width']}
                        initialValue={fields?.requestId}
                    >
                        <Input disabled/>
                    </Form.Item>
                    <Form.Item
                        name="requestDate"
                        label="Дата получения запроса"
                        className={styles['group-company-form__half-width']}
                        initialValue={fields?.requestDate}
                    >
                        <DateCell format="DD.MM.YYYY" disabled/>
                    </Form.Item>
                </div>
                <div className="d-flex gap-2">
                    <Form.Item
                        name="reportingDate"
                        label="Дата, по состоянию на которую предоставляются сведения"
                        className={styles['group-company-form__half-width']}
                        initialValue={fields?.reportingDate}
                    >
                        <DateCell format="DD.MM.YYYY" disabled/>
                    </Form.Item>
                    <Form.Item
                        name="inn"
                        label="ИНН Организации"
                        className={styles['group-company-form__half-width']}
                        initialValue={fields?.inn}
                    >
                        <Input disabled/>
                    </Form.Item>
                </div>
            </div>
        </section>
        <section>
            <h4 className={styles['group-company-form__title']}>
                Сведения о группе компаний, в составе которой учтена организация, по которой представлены сведения
            </h4>
            <Form.List name="companyGroupProtoGroupInfoDtos">
                {(fieldsList, operations) => {
                    if (fieldsList.length === 0) {
                        operations.add();
                    }

                    return (
                        <div>
                            {fieldsList.map((field) => (
                                <GroupCompanyOrgInfoItem
                                    form={formInstance}
                                    field={field}
                                />
                            ))}
                        </div>
                    );
                }}
            </Form.List>
        </section>

        <Form.Item
            name="id"
            hidden
        />
    </Form>
);